module.exports = __webpack_public_path__ + "static/img/erp3c.3a9bf44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erp3c.png
// module id = kE/q
// module chunks = 73